// @flow

import React from 'react';

import { StyledHr } from './styles';

const Hr = (props: Object) => <StyledHr {...props} />;

export default Hr;
